import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { SearchDefaultValue, SearchValue } from "./types";
import { OrganizationsState } from "../types/organization";

const initialState: OrganizationsState = {
  searchValue: SearchDefaultValue,
  isActive: true,
};

export const organizations = createSlice({
  name: "organizations",
  initialState,
  reducers: {
    setSearchValue: (state, action: PayloadAction<SearchValue>) => {
      state.searchValue.name = action.payload.name;
    },
    setIsActive: (state) => {
      state.isActive = !state.isActive;
    },
  },
});

export const { setSearchValue, setIsActive } = organizations.actions;

export const selectSearchValue = (state: { organizations: OrganizationsState }) =>
  state?.organizations?.searchValue;
export const selectIsActive = (state: { organizations: OrganizationsState }) =>
  state?.organizations?.isActive;

export default organizations.reducer;
